<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            تنفيذ السياسات والأنظمة الإدارية
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            مدى تطبيق بروتوكولات وزارة الصحة والأنظمة الإدارية
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-governance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">4/9</div>
          <div class="kpi-label">تطبق بروتوكولات MoPHP كاملاً</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">3/9</div>
          <div class="kpi-label">تطبيق جزئي</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">2/9</div>
          <div class="kpi-label">لا تطبق</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">6/9</div>
          <div class="kpi-label">لديها لوائح داخلية</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">مستوى تطبيق السياسات</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>بروتوكولات MoPHP</th>
            <th>اللوائح الداخلية</th>
            <th>سياسة الموارد البشرية</th>
            <th>سياسة الجودة</th>
            <th>IPC Policy</th>
            <th>درجة الامتثال/100</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="policyColor(item.mophp)"
                size="small"
                variant="flat"
                >{{ item.mophp }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="yesNoColor(item.internalRegulations)"
                size="small"
                variant="flat"
                >{{ item.internalRegulations }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="policyColor(item.hrPolicy)"
                size="small"
                variant="flat"
                >{{ item.hrPolicy }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="policyColor(item.qualityPolicy)"
                size="small"
                variant="flat"
                >{{ item.qualityPolicy }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="policyColor(item.ipcPolicy)"
                size="small"
                variant="flat"
                >{{ item.ipcPolicy }}</v-chip
              >
            </td>
            <td
              class="font-weight-bold"
              :class="scoreClass(item.complianceScore)"
            >
              {{ item.complianceScore }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    mophp: "جزئي",
    internalRegulations: "نعم",
    hrPolicy: "جزئي",
    qualityPolicy: "لا",
    ipcPolicy: "جزئي",
    complianceScore: 48,
  },
  {
    name: "مستشفى الأمراض النفسية",
    mophp: "لا",
    internalRegulations: "لا",
    hrPolicy: "لا",
    qualityPolicy: "لا",
    ipcPolicy: "لا",
    complianceScore: 20,
  },
  {
    name: "مجمع الشيخ عثمان",
    mophp: "كامل",
    internalRegulations: "نعم",
    hrPolicy: "كامل",
    qualityPolicy: "جزئي",
    ipcPolicy: "كامل",
    complianceScore: 72,
  },
  {
    name: "مركز كود العثماني",
    mophp: "كامل",
    internalRegulations: "نعم",
    hrPolicy: "جزئي",
    qualityPolicy: "جزئي",
    ipcPolicy: "كامل",
    complianceScore: 68,
  },
  {
    name: "مركز الممدارة",
    mophp: "كامل",
    internalRegulations: "نعم",
    hrPolicy: "كامل",
    qualityPolicy: "كامل",
    ipcPolicy: "كامل",
    complianceScore: 85,
  },
  {
    name: "مركز المحاريق",
    mophp: "جزئي",
    internalRegulations: "لا",
    hrPolicy: "لا",
    qualityPolicy: "لا",
    ipcPolicy: "لا",
    complianceScore: 30,
  },
  {
    name: "مركز عبد القوي",
    mophp: "كامل",
    internalRegulations: "نعم",
    hrPolicy: "كامل",
    qualityPolicy: "جزئي",
    ipcPolicy: "كامل",
    complianceScore: 80,
  },
  {
    name: "مركز ماري ستبوس",
    mophp: "لا",
    internalRegulations: "جزئي",
    hrPolicy: "لا",
    qualityPolicy: "لا",
    ipcPolicy: "لا",
    complianceScore: 25,
  },
  {
    name: "جمعية حقوق الطفل",
    mophp: "جزئي",
    internalRegulations: "نعم",
    hrPolicy: "جزئي",
    qualityPolicy: "جزئي",
    ipcPolicy: "جزئي",
    complianceScore: 55,
  },
];

const policyColor = (value) => {
  if (value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const yesNoColor = (value) => {
  if (value === "نعم") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const scoreClass = (value) => {
  if (value >= 70) return "text-green-darken-2";
  if (value >= 40) return "text-orange-darken-2";
  return "text-red-darken-2";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
